import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import MobileBreakpoints, {
  MobileFirst,
} from "../../settings/MobileBreakpoints";
import { ADAFont, FontWithLineHeight } from "../../settings/FontFormat";
import BoxShadow from "../../settings/BoxShadow";

const Theme = ({ children, platformConfigs }) => {
  return (
    <ThemeProvider
      theme={{
        primaryFont: platformConfigs.primary_font,
        secondaryFont: platformConfigs.secondary_font,
        primaryColor: `#${platformConfigs.primary_color}`,
        secondaryColor: `#${platformConfigs.secondary_color}`,
        btnColor: `#${platformConfigs.btn_color}`,
        btnHoverColor: `#${platformConfigs.btn_hover_color}`,
        btnPressedColor: `#${platformConfigs.btn_pressed_color}`,
        sideNavBackgroundColor: `#${platformConfigs.side_nav_color}`,
        sideNavTextColor: `#${platformConfigs.side_nav_text_color}`,
        backgroundColor: `#${platformConfigs.background_color}`,
        logoImage: platformConfigs.logo_image_url,
        cashForwardHeaderImage: platformConfigs.cash_forward_header_img_url,
        cashbackOptionsHeaderImage: platformConfigs.cashback_options_image_url,
        charityOptionsHeaderImage: platformConfigs.charity_options_image_url,
        dashboardHeaderImage: platformConfigs.dashboard_header_image_url,
        fontImportUrl: platformConfigs.font_import_url,
        platformIdentifier: platformConfigs.identifier,
        instayHeaderImageUrl: platformConfigs.instay_header_img_url,
        successNotificationColor: "#19623C",
        notificationsColor: `#${platformConfigs.notifications_color}`,
        tableDividerColor: `#${platformConfigs.table_divider_color}`,
        tableTooltipColor: `#${platformConfigs.table_tooltip_color}`,
        platformName: platformConfigs.platform_name,
        platformRewardsText: platformConfigs.platform_rewards_text,
        rewardsPageUrl: platformConfigs.rewards_page_url,
        operationsEmail: platformConfigs.operations_email,
        ...MobileBreakpoints,
        ...MobileFirst,
        ADAFont,
        FontWithLineHeight,
        BoxShadow,
      }}
    >
      {children}
    </ThemeProvider>
  );
};

Theme.propTypes = {
  children: PropTypes.any.isRequired,
  platformConfigs: PropTypes.object,
};

Theme.defaultProps = {
  platformConfigs: {
    primary_font: "'Roboto Mono', sans-serif",
    secondary_font: "'Inter', sans-serif",
    primary_color: "2D3145",
    secondary_color: "785827",
    btn_color: "292C2C",
    btn_hover_color: "555F66",
    btn_pressed_color: "111415",
    side_nav_text_color: "FFFFFF",
    side_nav_color: "111415",
    background_color: "FFFEFC",
    table_divider_color: "DADADA",
    table_tooltip_color: "000000",
    platformName: "The Guestbook",
    platformRewardsText: "rewards",
  },
};

export default Theme;
